import LightBulb from '@strata-monorepo/shared-ui/images/icons/LightBulb'

interface TooltipProps {
  content: string
}

export function Tooltip(props: TooltipProps) {
  const { content } = props

  return (
    <div className='strata:bg-system-information-alt-background strata:text-system-information-alt-foreground strata:rounded-sm strata:px-4 strata:py-2 strata:flex strata:items-center strata:gap-2 strata:text-body-xs strata:@qm/qc:text-body-sm'>
      <LightBulb className='strata:h-4 strata:w-4 strata:flex-shrink-0' />
      <p>{content}</p>
    </div>
  )
}
